import { useSyncExternalStore } from 'react';
import { clipAvailabilityStatus } from '@/stores/clipAvailabilityStatus';

export const useClipAvailabilityStatus = (clipId: string) => {
  const store = useSyncExternalStore(clipAvailabilityStatus.subscribe, clipAvailabilityStatus.getSnapshot);
  return {
    status: store[clipId]
  };
};
